import { Button } from '../../atomic/buttons';
import { useCreateTenantDialog } from './TenantFormDialog';

export const TenantCreate = ({}) => {
    const tenantCreate = useCreateTenantDialog();
    return (
        <>
            <div className="create_tenant_button">
                <Button className="primary" onClick={tenantCreate.show}>
                    テナント作成
                </Button>
                {tenantCreate.dialog}
            </div>
        </>
    );
};
